'use strict'
/**
 * usv.js — Contrato USV-v0 (MACRO 1 · Ola 2).
 *
 * El User State Vector TAL COMO SE PERSISTE HOY en user_state_vectors
 * (8 estados jsonb + metadatos de cálculo). NO son las ~150 variables
 * del Sprint 20 — esto prepara el terreno para que el SFPP construya
 * sobre esquema, no sobre barro.
 *
 * PRODUCTOR: src/routes/onboardingC8Routes.js (seed inicial vía
 *            'manual_recalc') + futuros recálculos del motor
 * CONSUMIDOR: progressRoutes (select *), domainsRoutes (fetchCtx)
 *
 * CHECK constraint real de la tabla:
 *   trigger_type ∈ {daily_cron, post_activity, wearable_sync, manual_recalc}
 */

const { z } = require('./z')

const TriggerType = z.enum(['daily_cron', 'post_activity', 'wearable_sync', 'manual_recalc'])

// Cada estado es un jsonb de variables del dominio — shape interno
// abierto (las ~150 variables del Sprint 20 se tiparán AQUÍ cuando existan)
const DomainState = z.record(z.string(), z.unknown())

const UsvV0Schema = z
  .object({
    user_id: z.string().uuid(),
    calculated_at: z.string(),
    trigger_type: TriggerType,
    calculation_version: z.string(),
    confidence_map: z.record(z.string(), z.unknown()),
    calculation_inputs: z.record(z.string(), z.unknown()).optional(),
    state_neural: DomainState,
    state_muscular: DomainState,
    state_articular: DomainState,
    state_metabolic: DomainState,
    state_hormonal: DomainState,
    state_cardiovascular: DomainState,
    state_sleep: DomainState,
    state_nutritional: DomainState,
  })
  .passthrough()

module.exports = { UsvV0Schema, TriggerType }
